/** Curated abbreviations; full species string stays stored in data. Keys are lowercased, normalized spaces. */
const SPECIES_ABBREV: Record<string, string> = {
  'white oak': 'WO',
  'red oak': 'RO',
  'western red cedar': 'WRC',
  cypress: 'C',
  'eastern white pine': 'EWP',
  'douglas fir': 'DF',
  'douglas-fir': 'DF',
  'southern yellow pine': 'SYP',
  'northern white cedar': 'NWC',
  'atlantic white cedar': 'AWC',
  'alaska yellow cedar': 'AYC',
  'western hemlock': 'WH',
  'eastern hemlock': 'EH',
  'ponderosa pine': 'PP',
  'red pine': 'RP',
  'white pine': 'WP',
  'red cedar': 'RC',
  spruce: 'S',
  pine: 'P',
  fir: 'F',
  hemlock: 'H',
};

function normalizeMoistureForDisplay(raw?: string | null): 'green' | 'kiln_dried' | 'unspecified' {
  const s = (raw || '').toLowerCase().trim();
  if (s === 'green' || s === 'grn') return 'green';
  if (s === 'kiln_dried' || s === 'kiln' || s === 'kd') return 'kiln_dried';
  return 'unspecified';
}

/** Short label for timber species (initials or curated code). Storage values remain full names. */
export function abbreviateSpeciesName(species: string): string {
  const key = species.trim().toLowerCase().replace(/\s+/g, ' ');
  if (!key) return '—';
  if (SPECIES_ABBREV[key]) return SPECIES_ABBREV[key];
  const parts = key.split(' ').filter(Boolean);
  if (parts.length === 1) {
    return parts[0]![0]!.toUpperCase();
  }
  return parts.map(p => p[0]!.toUpperCase()).join('');
}

/** Compact dryness label for UI (values in data unchanged). */
export function abbreviateTimberDrynessDisplay(raw?: string | null): string {
  const m = normalizeMoistureForDisplay(raw);
  if (m === 'green') return 'GRN';
  if (m === 'kiln_dried') return 'KD';
  return '—';
}

/** Full-word dryness label for client-facing copy; empty when unspecified. */
export function expandTimberDryness(raw?: string | null): string {
  const m = normalizeMoistureForDisplay(raw);
  if (m === 'green') return 'Green';
  if (m === 'kiln_dried') return 'Kiln Dried';
  return '';
}
